function Cta({
    text,
    link = "",
    idAnchor = "",
    className = "",
}) {
    const buttonClasses = `cta ${className}`.trim();

    const handleClick = (e) => {
        if (idAnchor && !link) {
            e.preventDefault();
            const targetElement = document.getElementById(idAnchor);
            if (targetElement) {
                const offset = 80;
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    const href = link ? `${link}${idAnchor ? `#${idAnchor}` : ""}` : idAnchor ? `#${idAnchor}` : undefined;

    return (
        <a className={buttonClasses} href={href} onClick={handleClick}>
            {text}
        </a>
    );
}

export default Cta;
